import {
	FrontendCompanySampleMatrix,
	FrontendCompanyTestCategory,
	FrontendCompanyWithAdditionalInfomation,
	FrontendSampleSpecification,
	FrontendSampleSpecificationDirectory,
	FrontendUserInfo,
} from "node-library/dist/portal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { GreenButton } from "../button";
import CreateSpecificationNoteModalContent from "../modals/modalContents/createSpecificationNoteModalContent";
import UnsavedChangesModal from "../modals/unsavedChangesModal";
import { useSnackbar } from "../toast/showToastMessage";
import { CustomDrawer } from "./drawer";

interface Props {
	company: FrontendCompanyWithAdditionalInfomation;
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>;
	user: FrontendUserInfo;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;

	testCategory: FrontendCompanyTestCategory;
	selectedMatrix: FrontendCompanySampleMatrix;
	updateSpecification: (spec: FrontendSampleSpecification) => void;

	specDirectories: Array<FrontendSampleSpecificationDirectory>;

	selectedSpecFile: FrontendSampleSpecification;
}

export default function CreateOrUpdateSpecificationReadingDrawer(props: Props) {
	const { t: translation } = useTranslation();
	const { openSnackbar } = useSnackbar();

	const {
		company,
		setCompany,
		user,
		testCategory,
		open,
		setOpen,
		selectedMatrix,
		updateSpecification,
		specDirectories,
		selectedSpecFile,
	} = props;

	const [currentFolder, setCurrentFolder] = useState<
		FrontendSampleSpecificationDirectory | undefined
	>();

	const [unsavedChangesModalOpen, setUnsavedChangesModalOpen] =
		useState<boolean>(false);
	const [unsavedChanges, setUnsavedChanges] = useState<boolean>(false);

	const getBreadcrumbs = () => {
		const crumbs: Array<FrontendSampleSpecificationDirectory> = [];
		let tempFolder = currentFolder;

		while (tempFolder) {
			crumbs.unshift(tempFolder); // Add to the beginning of array
			// Find the parent of the current temp folder
			tempFolder = specDirectories.find(
				(dir) => dir.directoryId === tempFolder?.parentDirectoryId,
			);
		}
		return crumbs;
	};

	const breadcrumbs = getBreadcrumbs();

	let content: React.ReactNode = (
		<div>
			<CreateSpecificationNoteModalContent
				user={user}
				company={company}
				setCompany={setCompany}
				testCategory={testCategory}
				selectedMatrix={selectedMatrix}
				updateSpecification={updateSpecification}
				currentFolderBreadcrumbs={breadcrumbs}
				selectedSpecFile={selectedSpecFile as FrontendSampleSpecification}
				setUnsavedChanges={setUnsavedChanges}
			></CreateSpecificationNoteModalContent>
			<div style={{ display: "flex", justifyContent: "center" }}>
				<GreenButton
					id={"spec-finish-button"}
					size="small"
					onClick={() => {
						setDrawerOpen(false);
					}}
				>
					{translation("Finish")}
				</GreenButton>
			</div>
		</div>
	);

	function setDrawerOpen(drawerOpen: boolean) {
		if (!drawerOpen && unsavedChanges) {
			setUnsavedChangesModalOpen(true);
		} else {
			setOpen(drawerOpen);
		}
	}
	const createOrEditReadingDrawer: React.ReactNode = (
		<CustomDrawer
			anchor={"right"}
			open={open}
			setOpen={setDrawerOpen}
			headerText={translation("ManageReading")}
			headerDescription={translation("ManageReadingDescription")}
			drawerWidth={`100%`}
		>
			{content}
		</CustomDrawer>
	);

	return (
		<>
			{createOrEditReadingDrawer}
			<UnsavedChangesModal
				open={unsavedChangesModalOpen}
				setOpen={setUnsavedChangesModalOpen}
				setUnsavedChanges={setUnsavedChanges}
				proceedAction={() => {
					setUnsavedChanges(false);
					setOpen(false);
				}}
			></UnsavedChangesModal>
		</>
	);
}
